import { Square } from 'lucide-react';

/** Hover checkbox in the result action cluster. Clicking it starts a selection without reserving a checkbox column. */
export default function ResultSelectOverlay({
  label,
  onToggle,
  className,
}: {
  label: string;
  onToggle: (shiftKey: boolean) => void;
  className: string;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      title="Select"
      onClick={(event) => {
        event.stopPropagation();
        onToggle(event.shiftKey);
      }}
      className={className}
    >
      <Square className="w-4 h-4" />
    </button>
  );
}
